const idadeTotalMeses = (anos: number, meses: number) => {
  return (Number(anos || 0) * 12 + Number(meses || 0)) * 31
}

export const isPresenteComAtraso = (anos: number, meses: number, faixaEtariaFim: number) =>
  idadeTotalMeses(anos, meses) > faixaEtariaFim
